import CardWrapper from "components/Common/CardWrapper";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button, Col,
} from "reactstrap";
import ApplyBonus from "../ApplyBonus/ApplyBonus";
import Details from "./details";

function RequestBonus(props) {
  const { t } = useTranslation();
  const [selectedBonus, setSelectedBonus] = useState();
  const [showModal, setShowModal] = useState(false);
  const [detailsShowModal, setDetailsShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");
  const baseUrl = process.env.REACT_APP_API_CP_DOMAIN;

  return <>

    <Col xs="12" md="6" lg="4" >
      <CardWrapper className="pt-0 px-0 shadow" style={{ 
        cursor: "pointer",
        overflow: "hidden",
      }} >
        <div 
          style={{
            minHeight: "250px",
          }}
        >
          <img
            src={`${baseUrl}/assets/${props.bonusDetails?.banner}`}
            alt="Banner"
            style={{ 
              width: "100%", 
              minHeight: "250px",
            }}
          />   
        </div>
        <div className="d-flex align-items-center justify-content-center mt-3 px-3">
          <div className="d-flex flex-column">
            <h4 className="lh-sm">{t(props.bonusDetails?.bonusName)}</h4>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <Button className="btn-blue btn-outline-dark text-white border-0 w-25" onClick={()=>{
            setSelectedContent({
              type: "json",
              content: { 
                bonusName:props.bonusDetails?.bonusName,
                amount:props.bonusDetails?.amount,
                maxAmount:props.bonusDetails?.maxAmount,
                accountGroup:props.bonusDetails?.accountGroup,
                bonusType:props.bonusDetails?.bonusType,
                duration:props.bonusDetails?.duration,
                desc:props.bonusDetails?.desc
              },
            });
            setDetailsShowModal(true);
          }} >
            { t("Details")}
          </Button>    
          <Button className="btn-success btn-outline-dark  text-white border-0 ms-3 w-25 " onClick={()=>{
            setSelectedBonus(props.bonusDetails);

            setShowModal(true);
          }} >
            { t("Apply")}
          </Button>    
        </div>
      </CardWrapper>
    </Col>
    <ApplyBonus showModal={showModal} bonus={selectedBonus} t={t} toggleModal={()=> setShowModal(false)}/>
    <Details  bonus={selectedBonus} t={t}   content={selectedContent}
      open={detailsShowModal}
      onClose={() => setDetailsShowModal(false)}/>
 
  </>;
}

export default RequestBonus;